<div class="card form-consulta">
  <img class="logo" src="assets/images/logoMpdft.png" alt="MPDFT">
    <h4 style="margin-bottom: 20px; text-align: center">Verificar Documento</h4>

  <form #formulario="ngForm">
    <div class="form-group" style="margin-bottom: 20px;">
      <div style="width: 312px; margin: 10px 10px;">
        <mat-form-field class="form-control">
          <mat-label>Nº do protocolo</mat-label>
          <input matInput [(ngModel)]="numeroProtocolo"
                 maxlength="21"
                 required
                 name="numeroProtocolo"
                 mask="00000.000000/0000-00">
        </mat-form-field>
      </div>
      <div style="width: 312px; margin: 10px 10px;">
        <mat-form-field class="form-control">
          <mat-label>Data da assinatura</mat-label>
          <input matInput type="date" [(ngModel)]="dataAssinatura" maxlength="32" required name="dataAssinatura">
        </mat-form-field>
      </div>
    </div>

    <div style="margin: 0 auto;display: table">
      <re-captcha id="recaptcha" name="recaptcha" #recaptcha="ngModel" [(ngModel)]="token" required
        [class.is-invalid]="recaptcha.invalid && (recaptcha.dirty || recaptcha.touched)">
      </re-captcha>
    </div>

    <button type="submit" class="btn btn-primary" style="margin-top: 20px;" [disabled]="formulario.invalid" (click)="enviar(formulario)">Consultar</button>
  </form>

  <div style="margin-top: 20px; align-self: center;">
    <mat-spinner *ngIf="carregando"></mat-spinner>
  </div>

</div>

  <div style="text-align: center; margin-top: 20px">
    <h6>Versão 2.0.0</h6>
  </div>


  <div class="atencao">
    <strong>Aten&ccedil;&atilde;o:</strong> Verifique se a pop-up do seu navegador est&aacute; desbloqueada.
  </div>

